import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Flex,
    Heading,
    Text,
    Button,
    useBreakpointValue
} from '@salesforce/retail-react-app/app/components/shared/ui'
import {FormattedMessage} from 'react-intl'
import {useHistory} from 'react-router-dom'
import {ErrorIcon, LeftArrow} from '../icons'

const MaintenancePage = ({heading, title, message}) => {
    const history = useHistory()
    const isMobile = useBreakpointValue({base: true, md: false})

    return (
        <Box
            width={{base: '100%', lg: '458px'}}
            display={'flex'}
            flexDirection={'column'}
            gap={'24px'}
        >
            <Text as="h1" textStyle="webH1">
                {heading}
            </Text>

            <Flex flexDirection={'column'} gap={'12px'}>
                <Box display={'flex'} flexDirection={'row'} alignItems={'center'} gap={'8px'}>
                    <ErrorIcon boxSize={'16px'} />
                    <Text as={'h4'} textStyle="webH4" textTransform="capitalize" fontWeight={'500'}>
                        {title}
                    </Text>
                </Box>

                <Text
                    fontSize={{base: '12px', lg: '14px'}}
                    fontWeight={400}
                    lineHeight={{base: '18px', lg: '20px'}}
                >
                    {message}
                </Text>
            </Flex>

            <Button
                variant="solid"
                colorScheme="blue"
                onClick={() => history.push('/')}
                w={{base: '100%', lg: '225px'}}
            >
                <FormattedMessage defaultMessage="Continue Shopping" id="maintenance_page.cta" />
            </Button>
        </Box>
    )
}

MaintenancePage.propTypes = {
    title: PropTypes.string.isRequired,
    message: PropTypes.string.isRequired,
    heading: PropTypes.string.isRequired,
}

export default MaintenancePage
